import React, { useMemo } from "react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Table from "../../../../Components/UiComponents/Table/Table";
import { getMealsDetailsURL } from "../../../../Services/EndPoints";
import { postDataWithBody } from "../../../../Services/Services";
import { text } from "@fortawesome/fontawesome-svg-core";
import "./FireDashboard.css";

const FireAffectedPopupData = ({ blockData }) => {
  // Calculate the total affected count
  const totalCount = blockData?.reduce(
    (sum, block) => sum + (Number(block.count) || 0), // Ensure we're adding numbers
    0
  );

  // Format number function
  const formatNumber = (num) => {
    if (num === null || num === undefined) return '';
    const number = Number(num);
    if (isNaN(number)) return num; // Return as-is if not a number
    
    // Check if it's an integer
    if (Number.isInteger(number)) {
      return number.toString();
    }
    
    // For decimals, round to 5 places and remove trailing zeros
    const rounded = parseFloat(number.toFixed(5));
    return rounded.toString();
  };

  // Append a "Total" row to the block data
  const dataWithTotal = useMemo(() => {
    if (!blockData || blockData.length === 0) return [];
    return [
      ...blockData.map(item => ({
        ...item,
        formattedCount: formatNumber(item.count)
      })),
      {
        block_name: "TOTAL",
        count: totalCount,
        formattedCount: formatNumber(totalCount)
      },
    ];
  }, [blockData, totalCount]);

  const columns = useMemo(
    () => [
      {
        Header: () => (
          <div style={{ textAlign: "left", marginLeft: "10pt" }}>
            Block Name
          </div>
        ),
        accessor: "block_name",
        disableSortBy: true,
        Cell: ({ value }) => (
          <div
            className="table-cell-left"
            style={{
              color: value === "TOTAL" ? "#17A3A0" : "inherit",
              fontWeight: value === "TOTAL" ? "bold" : "normal",
              fontSize: value === "TOTAL" ? "0.9rem" : "0.5",
            }}
          >
            {value}
          </div>
        ),
      },
      {
        Header: () => <div style={{ textAlign: "center" }}>Affected Count</div>,
        accessor: "formattedCount", // Changed to use formattedCount
        disableSortBy: true,
        Cell: ({ value, row }) => (
          <div
            className="table-cell-center"
            style={{
              color:
                row.original.block_name === "TOTAL" ? "#17A3A0" : "inherit",
              fontWeight: row.original.block_name === "TOTAL" ? "bold" : "normal",
              fontSize: row.original.block_name === "TOTAL" ? "0.9rem" : "0.8rem",
            }}
          >
            {value}
          </div>
        ),
      },
    ],
    []
  );
  
  return (
    <div>
      <div className="container create-user">
        <div className="datatable__container">
          {dataWithTotal && dataWithTotal.length > 0 ? (
            <Table
              data={dataWithTotal}
              addButtonLabel="Create UserTask"
              columns={columns}
              numberOfRows={7}
              showExport={false}
              showFilter={false}
              showReset={false}
              onExpand={false}
              headerTableHeadStyle={{ background: "#18a3a0", color: "#FFFFFF" }}
              tableStyle={{
                border: "1px solid  #f0f0f0",
                padding: "2px",
                borderRadius: "12px",
              }}
              applyTableHeaderCustomClass={true}
              disbalePaginationFilter={true}
              getHeaderProps={(column) => ({
                style: { textAlign: column.id === "formattedCount" ? "center" : "left" },
              })}
            />
          ) : (
            <p>No block-level data available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FireAffectedPopupData;